function topFunction(local, height) {
  /* event.preventDefault(); */

  // Seleciona o elemento local
  var element = document.querySelector(local);

  // Calcula a posição do elemento em relação ao topo da página
  var targetPosition = element.getBoundingClientRect().top + window.scrollY + height;

  // Faz a animação de scroll suave
  window.scrollTo({
    top: targetPosition,
    behavior: 'smooth'
  });
}
